<template>
    <p class="page-container">404 page not found</p>
</template>
<script>
export default {
    created(){
        
    }
}
</script>
<style lang="scss" scoped>
    .page-container {
        font-size: 20px;
        text-align: center;
        color: rgb(192, 204, 218);
    }
</style>


// WEBPACK FOOTER //
// 404.vue?06377006